/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types */
import React, {PureComponent, useEffect, useState} from 'react'
import {Alert} from 'react-bootstrap'
import {connect} from 'react-redux'

import globalConfirmation from 'live/services/global-confirmation'
import i18n from 'live/services/i18n'

import LinkedDashboards from 'plugin-liverig/shared/asset/components/dashboards/LinkedDashboards'
import {isMobile, getFilterString, ElementDimensions} from 'plugin-liverig/shared/asset/lib/utils'
import styled from 'styled-components'

import {actions} from './ducks/asset'
import {canManageRig, canSeeDashboards} from '../permission/index'
import {ASSET_TYPE} from './utils'

interface Props {
    selected: AssetReducerState['selected']
    linkDashboard: Function
    unlinkDashboard: Function
    fetchAsset: Function
    loading: boolean
    containerDimensions: ElementDimensions
}

interface State {
    showModal: boolean
    wellDashboards: {}
}

class RigDashboards extends PureComponent<Props, State> {
    state = {
        showModal: false,
        wellDashboards: []
    }
    unmounting = false

    componentDidMount() {
        const url = 'services/plugin-liverig/assets/well/' + this.props.selected.asset?.state?.well?.data?.id

        fetch(url)
            .then(result => {
                if (result.ok) {
                    return result.json()
                } else {
                    throw new Error()
                }
            })

            .then(items => this.setState({wellDashboards: items["dashboards"]}))
    }

    componentWillUnmount(): void {
        this.unmounting = true
    }

    toggleModal = (): void => {
        if (!this.unmounting) {
            this.setState(s => ({showModal: !s.showModal}))
        }
    }

    unlinkDashboard = (dashboard: LiveDashboard): void => {
        globalConfirmation.warn(
            <>{i18n('Are you sure you want to unlink this dashboard?')}</>,
            () => this.props.unlinkDashboard(this.props.selected.asset, dashboard),
            {btnText: i18n('Unlink')}
        )
    }

    onLink = (dashboard: LiveDashboard): void => {
        this.props.linkDashboard(this.props.selected.asset, dashboard)
        this.toggleModal()
    }

    render(): JSX.Element {
        const {selected, loading, containerDimensions} = this.props
        const canLinkDashboards = canSeeDashboards && canManageRig()

        return (
            <div>
                {selected.normalizer &&
                    (canSeeDashboards ? (
                        <div>
                            <div className="btn btn-primary">{i18n('Well Dashboards')} </div>
                            <LinkedDashboards
                                assetURL={ASSET_TYPE}
                                assetId={selected.asset.id}
                                unlinkDashboard={this.unlinkDashboard}
                                dashboards={this.state.wellDashboards}
                                readonly={true}
                                filters={'{"asset_name_event_type":["' + selected.asset.state.well?.data?.name + '"]}'}
                                loading={loading}
                                containerDimensions={containerDimensions}
                                marginTop={!isMobile && canLinkDashboards}
                            />
                            <div className="btn btn-primary">{i18n('Rig Dashboards')} </div>
                            <LinkedDashboards
                                assetURL={ASSET_TYPE}
                                assetId={selected.asset.id}
                                unlinkDashboard={this.unlinkDashboard}
                                dashboards={selected?.asset?.dashboards}
                                readonly={true}
                                filters={getFilterString(ASSET_TYPE, selected.asset.name, selected.normalizer?.event_type, {
                                    includeLegacyFilter: false
                                })
                                }
                                loading={loading}
                                containerDimensions={containerDimensions}
                                marginTop={!isMobile && canLinkDashboards}
                            />
                        </div>
                    ) : (
                        <Alert bsStyle="warning">
                            <p>{i18n('Access Forbidden: User does not have required permissions')}</p>
                        </Alert>
                    ))}
            </div>
        )
    }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = ({asset}: Record<string, any>) => ({
    selected: asset.selected,
    loading: asset.loading
})

const actionsAsProps = {
    linkDashboard: actions.linkDashboard,
    unlinkDashboard: actions.unlinkDashboard,
    fetchAsset: actions.fetchAsset
}

const BlankState = styled.div`
  padding: 30px;
  text-align: left;
  color: ${({ theme }) => theme.gray};
`
export default connect(mapStateToProps, actionsAsProps)(RigDashboards)
